import React from 'react';
import '../What.css';

export default ({ match }) => {
  return (
    <article className="page-content what-content">
      <section className="what-content-services">
        <div className="what-content-service">
          <h3>Services</h3>
          <ul>
            <li>
              Combining/organizing files into single PDF as “binding agreement”
            </li>
            <li>Submitting bound contract to Broker/office</li>
            <li>
              Introductory email and contract summary sent to client, co-op
              agent, lender & closing attorney
            </li>
            <li>
              Providing lenders with documents relating to the transaction as
              needed
            </li>
            <li>Initializing title work and attorney documents</li>
            <li>
              Adding all relevant dates to shared calendar & uploading all
              contract docs to shared cloud folder
            </li>
            <li>
              Coordinating inspection time and CBS code with co-op agent and
              client
            </li>
            <li>
              Acting as a liaison between lenders, attorney and clients faor
              document facilitation
            </li>
            <li>
              Assisting in managing deadlines, due diligence, financing and
              appraisal contingencies
            </li>
            <li>
              Drafting and executing basic amendments, such as closing, due
              diligence or contingency extensions - Coordinating appraisal and
              monitoring of appraisal status
            </li>
            <li>
              Sending updates to clients, lenders, attorneys and co-op agents on
              the progress of the transaction - Obtaining any outstanding
              documents – commission agreements, termite letters, etc.
            </li>
            <li>Scheduling closing and coordinating with all parties</li>
            <li>
              Following up with seller repairs and scheduling walk through
            </li>
            <li>Collecting termite letters/bond and ordering home warranty</li>
            <li>Coordinating utility information between buyers and sellers</li>
            <li>
              Emailing final contract package, wiring instructions and
              directions to all parties prior to closing
            </li>
            <li>Ensuring CD and loan package are sent out prior to closing</li>
            <li>Obtaining broker review/approval on final contract package</li>
            <li>
              Processing closed file and sending congratulations/wrap up email
              to all parties
            </li>
          </ul>
        </div>
      </section>
      <section className="what-content-rates">
        <h3>Rates</h3>
        <table className="rates-table">
          <tbody>
            <tr>
              <td className="rates-table-service">
                Transaction management (contract to close)
              </td>
              <td className="rates-table-price">$400</td>
            </tr>
          </tbody>
        </table>

        {/* <p className="rates-disclaimer">
          We understand that sometimes transactions just don’t work out and that these things are out of our control.
          Therefore, we allow one terminated contract per quarter FREE of charge. Additional terminated contracts are
          charged $50 each.
        </p> */}
      </section>
      <section>
        <h3>What's Not Included?</h3>
        <p>
          Our services are meant to minimize your involvement in the day to day
          busywork of transaction management, but there are some things you must
          remain responsible for:
        </p>
        <ul>
          <li>
            Verifying and ensuring that all contracts, amendments and exhibits
            are properly written.
          </li>
          <li>Meeting all contract deadlines and contingency expirations.</li>
          <li>
            Negotiating all terms of the contract and any following amendments.
          </li>
          <li>Collecting and depositing earnest money.</li>
          <li>
            Providing binding agreement dates, legal descriptions and writing
            detailed (non-standard) verbiage.
          </li>
          <li>
            Any visits to the property - to meet inspectors or appraisers, for
            repairs, to retrieve signs, lockboxes, etc.
          </li>
          <li>
            Attending the closing & turning checks/monies into your brokerage
          </li>
        </ul>
      </section>
    </article>
  );
};



// WEBPACK FOOTER //
// ./src/what/ContractManagement.js